var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEggCrack = function SvgIconEggCrack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.023 4.498q.354.453.684.947c1.587 2.38 2.793 5.57 2.793 8.805a8.5 8.5 0 1 1-17 0c0-3.234 1.206-6.424 2.793-8.805.796-1.193 1.71-2.217 2.656-2.953C9.876 1.77 10.934 1.25 12 1.25s2.124.52 3.051 1.242a11.5 11.5 0 0 1 1.872 1.88 1 1 0 0 1 .1.126M5.5 14.25c0-2.766 1.044-5.576 2.457-7.695.704-1.057 1.478-1.908 2.22-2.484.76-.591 1.389-.821 1.823-.821s1.064.23 1.824.82q.515.402 1.037.968l-3.436 3.829a1 1 0 0 0 .381 1.6l1.922.747-.516 2.658a1 1 0 1 0 1.964.381l.675-3.478a1 1 0 0 0-.62-1.123l-1.352-.526 2.225-2.479c1.382 2.108 2.396 4.877 2.396 7.603a6.5 6.5 0 1 1-13 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconEggCrack;